export default __webpack_public_path__ + "static/media/Bullet 02.f30b1d0c.webp";